import { useSessionStorage, type RemovableRef } from '@vueuse/core';
import { defineStore } from 'pinia';

export interface State {
  paymentData: RemovableRef<string | undefined>;
  paymentId: RemovableRef<string | undefined>;
}

export const usePaymentStore = defineStore('payment', {
  state: (): State => ({
    paymentData: useSessionStorage('payment/paymentData', undefined),
    paymentId: useSessionStorage('payment/paymentId', undefined),
  }),

  actions: {
    setPaymentData(data: string) {
      this.paymentData = data;
    },

    setPaymentId(id: string) {
      this.paymentId = id;
    },
  },
});
